import React, { FC, ReactElement } from 'react';
import classNames from 'classnames/bind';
import { PostType } from 'sections/Resources/FreightForwarder/landing/types';
import { Post } from 'sections/Resources/FreightForwarder/landing/components/SectionPosts/components/Post';
import Link from 'next/link';
import { TitleSvg } from 'sections/Resources/FreightForwarder/landing/assets/Svg';
import styles from 'sections/Resources/FreightForwarder/landing/components/SectionPosts/SectionPosts.module.scss';

const cn = classNames.bind(styles);

type PostsProps = {
  articles: PostType[];
};

const Posts: FC<PostsProps> = ({ articles }: PostsProps): ReactElement => {
  const postsElements = articles.map((item: PostType) => {
    return (
      <Post
        key={item.id}
        image={item.image}
        date={item.date}
        title={item.title}
        url={item.url}
      />
    );
  });

  return (
    <div className={cn('posts')}>
      <div className={cn('container')}>
        <h3 className={cn('posts__heading')}>
          <span className={cn('posts__heading-text')}>
            Related blog posts{TitleSvg}
          </span>
          <Link className={cn('posts__button-see')} href="/blog">
            See all
            <svg viewBox="0 0 10 10" aria-hidden="true">
              <path d="M1 5h7" />
              <path d="M2 1l4 4-4 4" />
            </svg>
          </Link>
        </h3>
        <div className={cn('posts__list')}>
          {postsElements}
        </div>
      </div>
    </div>
  );
};

export default Posts;
